export const SIZE_TYPE_150 = "150";
export const SIZE_TYPE_150_V2 = "150_V2";
export const SIZE_TYPE_150_V3 = "150_V3";
export const SIZE_TYPE_200 = "200";
export const SIZE_TYPE_150_HANJIN = "150_HANJIN";
